<script setup>
import DikeTrajectoryToggleChips from './DikeTrajectoryToggleChips.vue'
import SpeckleVersionSelect from '@/components/speckle/SpeckleVersionSelect.vue'
import { useSpeckleStore } from '@haskoning/vue-speckle'
import { storeToRefs } from 'pinia'
import { useProjectSpeckleStore } from '@/store/projectSpeckle'
import { useStore } from 'vuex'
import { computed } from 'vue'
import { useSpeckleManagement } from '@/composables/useSpeckleManagement'

const store = useStore()
const speckleStore = useSpeckleStore()
const projectSpeckleStore = useProjectSpeckleStore()
const speckleManagement = useSpeckleManagement()

const { allVersions } = storeToRefs(speckleStore)
const { connectToSpeckleDialog } = storeToRefs(projectSpeckleStore)

const currentProject = computed(() => store.state.project.currentProject)

const versionId = computed({
  get: () => currentProject.value.currentprojectuser.selected_speckle_version_id,
  set: (val) => {
    setSelectedSpeckleVersion(val)
  }
})

const setSelectedSpeckleVersion = (id) => {
  store.dispatch('project/setSelectedSpeckleVersion', id)
}
const updateCurrentProjectUserSpeckle = async () => {
  await store.dispatch('project/updateCurrentProjectUserSpeckle')
}
</script>
<template>
  <div class="px-4" style="display: flex">
    <SpeckleVersionSelect
      :items="allVersions"
      v-model="versionId"
      @update="updateCurrentProjectUserSpeckle"
      style="max-width: 350px"
      menu-icon="mdi-chevron-down"
      prepend-inner-icon="mdi-chart-line-variant"
      single-line
      density="compact"
      color="primary"
      class="mr-2"
    >
      <template v-slot:prepend-item>
        <div v-if="!speckleManagement.canUseSpeckle" class="d-flex center">
          <v-btn
            @click="connectToSpeckleDialog = true"
            class="text-none justify-center"
            prepend-icon="mdi-link-variant"
            variant="tonal"
          >
            Connect to Speckle project
          </v-btn>
        </div>
      </template>
    </SpeckleVersionSelect>
    <DikeTrajectoryToggleChips />
  </div>
</template>
